import { Head } from '@inertiajs/react';
import { parishName, useSite } from '@/hooks/useSite';

// Keeps the document title (and description) in sync during Inertia SPA
// navigation. The crawler- and social-facing metadata — canonical, Open Graph,
// Twitter, JSON-LD — is rendered server-side in the Rails layout from each
// controller's `set_seo`, so it lands in the raw HTML without JavaScript.
export default function Seo({ title, description }: { title: string; description?: string }) {
  const site = useSite();
  const full = `${title} · ${parishName(site)}`;
  return (
    <Head title={full}>{description && <meta name="description" content={description} />}</Head>
  );
}
